<template>
    <div>
        <Table
              style="margin-top: 20px;"
              stripe
              border
              ref="selection"
              :columns="columns"
              :loading="loading"
              :data="dataTable"
              @on-selection-change="handleSelect"
              @on-select-cancel="handleSelectCancel"
            >
            <template slot="slot1" slot-scope="{ row }">
                <Button type="primary" @click="sendPop(row)">发送</Button>
            </template>
        </Table>
        <Page :total="this.totalNum" style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:-10px" @on-change="pageChange" />
        <div class="btnGroup">
            <Button type="primary" @click="backPage()">返回</Button>
            <Button type="primary" @click="batchSendMail()" :disabled="btnDis" style="margin-left:20px">批量发送邮件</Button>
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            date:new DateUtil(),
            remindId:'',
            loading:false,
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columnsList:[
                {
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    fixed: 'left',
                },
               
                {
                    title: '发送邮件',
                    align: "center",
                    slot: "slot1",
                    width: 100,
                    fixed: 'right',
                }
            ],
            columns:[],
            dataTable:[],
            selectList:[],
            saveSelectList:[],
            spinShow:false,
            btnDis:true
        }
    },
    created(){
        this.remindId=this.$route.query.remindId
        this.getDate()
    },
    methods:{
        getDate(){
            let json={
                remindId:this.remindId,
            }
            this.loading=true
            axios.post('/remindModule/selectRemindTableHeadInfo',json).then(res => {
                if(res) {
                    let list=res.map((el) => {
                        return {
                            ...el,
                            key:el.viewKey,
                            title:el.chColumn,
                            width:1495/res.length
                        }
                    })
                    list.forEach((item,index) => {
                        
                        if(item.columnType=='Date'){
                            item.render=(h, params) => {
                                for(var key in params.row){
                                    if(key==item.viewKey){
                                         return h(
                                            "span",
                                            this.date.dateVal( params.row[key], "YYYY-MM-DD")
                                         );
                                    }
                                }
                               
                            }
                        }
                    })
                    list.unshift(this.columnsList[0])
                    list.push(this.columnsList[1])
                   
                    this.columns=list
                    this.getTableData()
                }
            })

        },
        getTableData(){
            let json={
                remindId:this.remindId,
                ...this.pageInfo
            }
            this.loading=true
            axios.post('/remindModule/selectRemindDetailInfo',json).then(res => {
                if(res) {
                    this.loading=false
                    this.dataTable=res.data
                    this.dataTable.forEach(item => {
                        if(this.saveSelectList.length>0){
                            this.saveSelectList.forEach(el => {
                                if(item.empcode==el.empCode){
                                    this.btnDis=true
                                    item._checked=true
                                }
                            })
                        }
                        // item._checked=true
                        // if(item.birthday){
                        //     item.birthday=this.date.dateVal(item.birthday, "YYYY-MM-DD")
                        // }
                    })
                    this.totalNum=Number(res.pageInfo.total)
                }
            })
        },
        sendPop(row){
            let list=[]
            this.$Modal.confirm({
                title: this.$notice('confirmToSend'),
                content: '',
                onOk: () => {
                    this.spinShow=true
                    list.push({remindId:this.remindId,empCode:row.empcode})
                    axios.post('/remindMail/sendBatchMailData',list).then(res => {
                        this.spinShow=false
                        if(res) {
                            this.$Message.success('发送邮件成功');
                        }
                    })
                }
            });
            
        },
        handleSelect (status) {
            status.length>0 ? this.btnDis=false : this.btnDis=true
           
            this.selectList=[]
            status.map(el => {
                this.selectList.push({remindId:this.remindId,empCode:el.empcode})
            })
        },
        handleSelectCancel(status,row){
            console.log('取消',row)
            this.saveSelectList.forEach((el,index) => {
                if(el.empCode==row.empcode){
                    this.saveSelectList.splice(index,1)
                }
            })
            
        },
        batchSendMail(){
            let list=[]
            this.$Modal.confirm({
                title: this.$notice('bulkSend'),
                content: '',
                onOk: () => {
                    this.spinShow=true
                    list=this.saveSelectList.concat(this.selectList)
                    list=Array.from(new Set(list))
                    axios.post('/remindMail/sendBatchMailData',list).then(res => {
                        this.spinShow=false
                        if(res) {
                            this.$Message.success('发送邮件成功');
                        }
                    })
                }
            });
        },
        
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getTableData()
            this.saveSelectList=this.saveSelectList.concat(this.selectList)
        },
        backPage(){
            this.$router.back()
        }
    }
}
</script>

<style scoped>
.btnGroup {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/ReminderDetails.vue